import React from 'react';

/**
 * The broker experience, loaded only when a broker opens it, so the library stays out of the main bundle. Shared
 * by every route that mounts it.
 */
export const LazyBrokerPersonaMount = React.lazy(
  () =>
    import(/* webpackChunkName: 'BrokerPersonaMount' */ './BrokerPersonaMount')
);

/** The broker experience inside the agency persona's layout, loaded the same way. */
export const LazyAgencyBrokerPersonaMount = React.lazy(
  () =>
    import(
      /* webpackChunkName: 'AgencyBrokerPersonaMount' */ './AgencyBrokerPersonaMount'
    )
);

/**
 * The broker dashboard at `/agency/dashboard`. It imports the light `@cowbell/broker/dashboard` entry, not the whole
 * library, so it keeps a chunk name of its own and is never grouped with the quote flow's mount.
 */
export const LazyAgencyBrokerDashboardMount = React.lazy(
  () =>
    import(
      /* webpackChunkName: 'AgencyBrokerDashboardMount' */ './AgencyBrokerDashboardMount'
    )
);
